import React, { useState, useEffect } from 'react';
import { X, Users } from 'lucide-react';

const recentEnrollments = [
  { name: "Michael T.", location: "Houston, TX", time: "2 minutes ago", company: "BuildRight Construction" },
  { name: "Sarah K.", location: "Chicago, IL", time: "5 minutes ago", company: "Pacific Manufacturing" },
  { name: "James R.", location: "Phoenix, AZ", time: "8 minutes ago", company: "SafeWorks Industrial" },
  { name: "Emily W.", location: "Seattle, WA", time: "12 minutes ago", company: "Premier Healthcare" },
  { name: "David L.", location: "Miami, FL", time: "15 minutes ago", company: "Atlantic Energy" },
  { name: "Jennifer M.", location: "Denver, CO", time: "18 minutes ago", company: "LogiFreight Inc." },
  { name: "Robert C.", location: "Boston, MA", time: "22 minutes ago", company: "TechSafe Solutions" },
  { name: "Lisa P.", location: "Atlanta, GA", time: "25 minutes ago", company: "Metro Construction" }
];

const RecentEnrollment = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (isDismissed) return;

    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);

    return () => clearTimeout(initialTimer);
  }, [isDismissed]);

  useEffect(() => {
    if (!isVisible || isDismissed) return;

    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      
      // Show next notification after 15-25 seconds
      const nextTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % recentEnrollments.length);
        setIsVisible(true);
      }, 15000 + Math.random() * 10000);

      return () => clearTimeout(nextTimer);
    }, 5000);

    return () => clearTimeout(hideTimer);
  }, [isVisible, currentIndex, isDismissed]);

  if (isDismissed || !isVisible) return null;

  const enrollment = recentEnrollments[currentIndex];

  return (
    <div 
      className="fixed bottom-24 left-6 z-40 animate-in slide-in-from-left-full duration-500"
      style={{ maxWidth: '320px' }}
    >
      <div className="bg-white rounded-xl shadow-2xl border border-slate-200 p-4 relative">
        {/* Close button */}
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute top-2 right-2 p-1 text-slate-400 hover:text-slate-600 transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-start gap-3 pr-6">
          {/* Avatar */}
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center flex-shrink-0">
            <Users className="w-5 h-5 text-white" />
          </div>

          {/* Content */}
          <div>
            <p className="text-sm text-slate-900">
              <span className="font-semibold">{enrollment.name}</span> from {enrollment.location}
            </p>
            <p className="text-xs text-slate-500 mt-0.5">
              just enrolled in the OSHA Training Course
            </p>
            <p className="text-xs text-emerald-600 mt-1">{enrollment.time}</p>
          </div>
        </div>

        {/* Verified badge */}
        <div className="mt-2 pt-2 border-t border-slate-100">
          <p className="text-xs text-slate-400 flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
            Verified enrollment
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecentEnrollment;
